import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IUserManagementDialogData } from '../../interfaces/user-management-dialog-data.interface';

@Component({
    selector: 'user-modification-confirmation-modal',
    templateUrl: './user-modification-confirmation-modal.component.html',
    styleUrls: ['./user-modification-confirmation-modal.component.scss'],
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class UserModificationConfirmationModal {
    constructor(
        @Inject(MAT_DIALOG_DATA) protected data: IUserManagementDialogData,
        private readonly dialogRef: MatDialogRef<UserModificationConfirmationModal, void>,
    ) {}

    applyActionAndClose(): void {
        this.data.action();
        this.closeDialog();
    }

    closeDialog(): void {
        this.dialogRef.close();
    }
}
